import http from "../http";

export default (axios, base) => ({
  accountItems: (monthYear) => http.get(`${base}/accountItems/${monthYear}`),
  update: (userIds) => http.put(`${base}/updateUsers`, userIds),
  updateHistory: () => http.get(`${base}/update/history`),
  exportHistory: () => http.get(`${base}/export/history`)
});
